import { FORM_ERROR } from 'final-form';
import { noop } from '../helpers';
import unpackApiError from './unpackApiError';

type SubmitSuccess = (response: Response) => unknown;

const rffSubmitResponse = (
  submitSuccess: SubmitSuccess = noop,
) => async (response: Response) => {
  if (!response.ok) {
    const error = await unpackApiError(response);
    return {
      [FORM_ERROR]: error.detail,
      code: error.code,
    };
  }
  return submitSuccess(response);
};

export default rffSubmitResponse;
